import { dateFormat, dateStringFormat, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult } from '../../orgDashboard/types'

export const useLaunchDateStatus = (
  org: OrganizationDetailFragment | null | undefined
): Pick<HealthcheckStatusResult, 'status' | 'primary' | 'secondary'> | null => {
  if (!org) return null
  const todayIso = dateFormat.isoDate(new Date())
  const isToday = org.launchDate === todayIso
  const isFuture = org.launchDate && org.launchDate > todayIso
  const isPast = org.launchDate && org.launchDate < todayIso

  // Component doesn't render if already launched
  if (org.isOnboarded && isPast) {
    return null
  }

  const primary = 'Launch date'

  if (!org.launchDate) {
    return {
      status: 'incomplete',
      primary,
      secondary: 'When should we send out invitations for your employees to enroll?',
    }
  }

  if (isToday) {
    return {
      status: 'complete',
      primary,
      secondary: 'Now your employees can use Alice for commuting benefits',
    }
  }

  if (isFuture) {
    const futureLaunchNotice = `Employees will receive enrollment notices starting on ${dateFormat.short(dateStringFormat.dateFromDateString(org.launchDate))}.`
    return {
      status: 'complete',
      primary,
      secondary: futureLaunchNotice,
    }
  }

  return null // don't need to show this item _after_ launch date
}
